import { enableFade } from 'core/handlers/FadeHandler'
import * as isWebview from 'is-ua-webview'
import { gameStorage } from 'services/ElementsStorageService'
import { signal } from 'services/SignalsService'
import { backEndVersion } from 'settings/custom/general'
import { spinSettings } from 'settings/custom/reels'

import { social } from '../../../settings/custom/build'

export default class MenuEntity extends PIXI.Container {
  constructor() {
    super()
    const fade = enableFade(this)

    signal.on('DISPLACEMENT:BUTTON', ({ orientation }) => {
      let socialMode = false
      let socialGame = false
      if(spinSettings.hasOwnProperty('socialMode')){
        socialMode = true
      }
      if(social && spinSettings.hasOwnProperty('socialGame')) {
        socialGame = true
      }

      if(game.models.GameModel.action === 'demo' || game.models.GameModel.mode === 'demo' ||  socialMode || socialGame) {
        this.removeChild(gameStorage.get('menuhistory'))
        this.children.forEach((item) => {
          if (item.name !== 'ui-menu'){
            if (orientation === 'land'){
              item.y = item.y + 40
            }
            else {
              item.x = item.x + 40
            }
          }
        })
      }
    })

    signal.on('RADIO:ui', (value) => {
      fade(value === 'menu')
      const isPaytable = value === 'menu' ? 'paytable' : ''
      signal.dispatch(`UI:RG:ENTITY${isPaytable ? ':HIDE' : ':SHOW'}`, true)
      signal.dispatch('RADIO:menu', isPaytable )
      if (value === 'menu'){
        signal.dispatch(`RADIO:menu:${isPaytable }`)
      }
      if (value === ''){
        signal.dispatch('RADIO:menu:all')
      }
    })
    // todo radio groups close on spin
    signal.on('STATE:OUT:BET', () => {
      signal.dispatch('RADIO:ui', false)
    })

    signal.on('BUTTON:menuhome', () => {
      if(game.models.GameModel.home === '') {
        return
      }
      window.top.location.href  = game.models.GameModel.home
    })

    signal.on('BUTTON:menuhistory', () => {
      if(backEndVersion === 2){
        if(isWebview(window.navigator.userAgent)){
          window.top.location.href  = game.models.GameModel.history
        }
        else {
          window.open(game.models.GameModel.history, '_blank').focus()
        }

      }
    })

    signal.on('BUTTON:menucashier', () => {
      if(game.models.GameModel.deposit === '') {
        return
      }
      window.top.location.href  = game.models.GameModel.deposit
    })
  }
}
